import { render, staticRenderFns } from "./modalVentasUltimos.vue?vue&type=template&id=26f29772&"
import script from "./modalVentasUltimos.vue?vue&type=script&lang=js&"
export * from "./modalVentasUltimos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports